import { t } from '@lingui/core/macro';
import moment from 'moment/moment';
import { getTranslation } from './translationUtils';

export function getCruisesInfo(cruises) {

    let cruiseDuration = 0;
    let cruiseName = "";
    const cruiseStart = cruises[0].fromDate;
    const shipName = cruises[0].ship.name;
    let cruiseEnd = "";

    cruises.forEach((cruise) => {
        cruiseDuration += cruise.numberOfDays;
        cruiseName += cruise.name.defaultValue + " & "
    });
    cruiseName = cruiseName.substring(0, cruiseName.length - 3);

    if(cruises && cruises.length) {
        cruiseEnd = moment.max(cruises.map(cruise => moment(cruise.fromDate, 'DD/MM/YYYY').add(cruise.numberOfDays, 'days'))).format("DD/MM/YYYY");
    }

    return {
        shipName,
        cruiseName,
        cruiseStart,
        cruiseEnd,
        cruiseDuration,
    };
}

export function formatPortName(type, port) {
    if(type === "Sea") {
        return t({id: "at_sea"}).toUpperCase();
    }
    return getTranslation(port.name).toUpperCase() + ", " + getTranslation(port.localizedCountryName).toUpperCase();
}